import { createBrowserHistory } from "history";

// react-router-dom v6에 존재하지 않는 history를 사용하기 위해 history를 따로 만들어줌
const history = createBrowserHistory();
export default history;